import { Link } from 'react-router-dom';
import { analysisRelatedTracks } from '@/mocks/forexAnalysisPage';

export default function RelatedTracks() {
  return (
    <section className="bg-primary-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[380px_1fr] lg:items-start lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-700">
              <span className="h-px w-6 bg-accent-500" />
              เรียนต่อ
            </span>
            <h2 className="mt-3 text-balance font-heading text-2xl font-semibold leading-tight text-foreground-950 md:text-[32px]">
              ต่อยอดความรู้ Forex ของคุณ
            </h2>
            <p className="mt-3.5 max-w-md text-sm leading-relaxed text-foreground-700">
              การวิเคราะห์กราฟเป็นเพียงส่วนหนึ่งของการเรียนรู้ Forex คุณสามารถศึกษาพื้นฐานตลาด
              วิธีใช้งานแพลตฟอร์ม และการบริหารความเสี่ยงเพิ่มเติมได้
            </p>
          </div>

          <ul className="grid grid-cols-1 gap-x-8 gap-y-2 sm:grid-cols-3">
            {analysisRelatedTracks.map((track) => (
              <li key={track.path} className="border-t border-primary-200 pt-4">
                <Link
                  to={track.path}
                  className="group flex h-full cursor-pointer flex-col transition-colors"
                >
                  <span className="flex items-center gap-2 text-xs font-semibold text-foreground-500">
                    <i className={`${track.icon} text-base text-primary-700`} aria-hidden="true" />
                    {track.meta}
                  </span>
                  <span className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {track.title}
                  </span>
                  <span className="mt-2 flex-1 text-[13px] leading-relaxed text-foreground-600">
                    {track.description}
                  </span>
                  <span className="mt-4 flex items-center gap-1.5 text-xs font-semibold text-primary-700">
                    ไปที่บทความ
                    <i
                      className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1"
                      aria-hidden="true"
                    />
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}